import React from "react";
import { AppstoreOutlined, DatabaseOutlined, TeamOutlined } from "@ant-design/icons";

/** Key of the submenu whose children are populated from the domains API. */
export const DATA_DOMAINS_KEY = "data_domains";

export interface SidebarNavItem {
  key: string;
  /** Plain-text label, also used to order the top-level items alphabetically. */
  label: string;
  icon: React.ReactNode;
  /** Tooltip content; falls back to the emphasized label. */
  tooltip?: React.ReactNode;
}

/** A top-level item that navigates straight to a route instead of expanding. */
export interface SidebarRouteNavItem extends SidebarNavItem {
  path: string;
}

export const DATA_DOMAINS_NAV_ITEM: SidebarNavItem = {
  key: DATA_DOMAINS_KEY,
  label: "Data Domains",
  icon: <DatabaseOutlined />,
};

/**
 * Static route-backed sidebar entries.
 * Maintain this list in code; ship features with the branch that deploys to each env.
 */
export const ROUTE_NAV_ITEMS: SidebarRouteNavItem[] = [
  {
    key: "access-groups",
    label: "Access Groups",
    icon: <TeamOutlined />,
    tooltip: "Access Groups",
    path: "/access-groups",
  },
  {
    key: "gallery",
    label: "Gallery",
    icon: <AppstoreOutlined />,
    tooltip: "Analytics Application Gallery",
    path: "/gallery",
  },
];

/** Orders top-level sidebar items A–Z, ignoring case and accents. */
export const compareNavItemsByLabel = (a: SidebarNavItem, b: SidebarNavItem): number =>
  a.label.localeCompare(b.label, undefined, { sensitivity: "base" });
